import React, { useEffect, useState } from "react";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm ${className}`}>{children}</div>;
}

export default function ClientWeeklyReport() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/client/weekly-report").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-sm text-slate-400">Loading report…</div>;

  const rows = [
    ["Contractors", data.contractor_count],
    ["Registered for training", data.registered_for_training],
    ["Training scheduled", data.training_scheduled],
    ["Training completed", data.training_completed],
    ["Ready for production", data.ready_for_production],
    ["Active contractors", data.active_contractors],
  ];

  return (
    <div className="space-y-4" data-testid="client-weekly-report">
      <Card>
        <h2 className="text-base font-bold text-slate-900">Weekly Report</h2>
        <p className="text-sm text-slate-500">Generated {new Date(data.generated_at).toLocaleString()} · summarizes your programs.</p>
      </Card>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
        {rows.map(([label, value]) => (
          <Card key={label}>
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">{label}</div>
            <div className="mt-2 text-2xl font-bold text-slate-900">{value}</div>
          </Card>
        ))}
      </div>
      <Card>
        <h3 className="text-sm font-bold text-slate-900">Production &amp; quality</h3>
        {data.production.available ? (
          <div className="mt-2 grid grid-cols-2 gap-4 sm:grid-cols-3">
            <div><div className="text-xs uppercase text-slate-400">Calls</div><div className="text-xl font-bold text-slate-900">{data.production.calls}</div></div>
            <div><div className="text-xs uppercase text-slate-400">Talk time</div><div className="text-xl font-bold text-slate-900">{data.production.talk_time}</div></div>
          </div>
        ) : (
          <div className="mt-2 text-sm text-amber-600" data-testid="report-no-production">{data.production.message}</div>
        )}
      </Card>
    </div>
  );
}
